
import { Component, Injectable, Inject } from '@angular/core';
import {MatSnackBar, MatSnackBarRef, SimpleSnackBar, MAT_SNACK_BAR_DATA} from '@angular/material';

/**
 * @title Snack-bar with a custom component
 */
@Injectable({
  providedIn: 'root'
})
export class ToastMessage {
  constructor(public snackBar: MatSnackBar) {}

  openSnackBarSuccess(message) {
    this.snackBar.openFromComponent(ToastSnackbar, {
      duration: 3000,
      panelClass: ['mat-snack-bar-container'],
      data: message
    });
  }
  openSnackBarError(message, duration = 5000) {
    this.snackBar.openFromComponent(ToastSnackbar, {
      duration: duration,
      panelClass: ['mat-snack-error-container'],
      data: message
    });
  }

  /**
   * Sticky red error snackbar (same look as openSnackBarError).
   * duration 0 = no auto-dismiss; closes only when user clicks ✕.
   */
  openSnackBarErrorSticky(message: string): MatSnackBarRef<SimpleSnackBar> {
    return this.snackBar.open(message, '✕', {
      duration: 0,
      panelClass: ['mat-snack-error-container', 'mat-snack-error-sticky'],
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
  }
}


@Component({
  selector: 'toast-snackbar',
  template: require('./toast-snackbar.html')
})
export class ToastSnackbar {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any){
   
  }
}


/**  Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license */
